import { render, staticRenderFns } from "./InstaBlack.vue?vue&type=template&id=f5aa0d94&scoped=true&"
import script from "./InstaBlack.vue?vue&type=script&lang=js&"
export * from "./InstaBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aa0d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5aa0d94')) {
      api.createRecord('f5aa0d94', component.options)
    } else {
      api.reload('f5aa0d94', component.options)
    }
    module.hot.accept("./InstaBlack.vue?vue&type=template&id=f5aa0d94&scoped=true&", function () {
      api.rerender('f5aa0d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/InstaBlack.vue"
export default component.exports